import packageJson from '@/../package.json';
import * as types from '../types';

// Initial state
// -------------
const state = {
    version:  (packageJson.version !== undefined) ? packageJson.version : null,
    isMobile: (window.innerWidth < 800),
};

// Getters
// -------
const getters = {
    version:  state => state.version,
    isMobile: state => state.isMobile,
};

// Mutations
// ---------
const mutations = {
    /**
     * Est-ce un mobile ?
     *
     * @author Fabien Bellanger
     * @param {Object}   state
     * @param {Boolean}  isMobile
     */
    [types.M_APP_ISMOBILE](state, isMobile)
    {
        state.isMobile = isMobile;
    },
};

// Actions
// -------
const actions = {
    /**
     * Enregistrement d'une chanson
     *
     * @author Fabien Bellanger
     * @param {Object}   store
     * @param {Boolean}  isMobile
     */
    [types.A_APP_ISMOBILE](store, isMobile)
    {
        store.commit(types.M_APP_ISMOBILE, isMobile);
    },
};

export default {
    state,
    getters,
    mutations,
    actions,
};
